import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { EmployeesService } from '../../../services/employees/employees.service';
import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';
import { SegmentEventName } from '@unico-people/shared/enums/utils-enums';
import { DataAccessFeatureFlagService } from '@unico-people/shared/data-access/data-access-feature-flag';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Component({
  selector: 'employee-signatures',
  templateUrl: './employee-signatures.component.html',
  styleUrls: ['./employee-signatures.component.scss']
})
export class EmployeeSignaturesComponent implements OnInit {
  @Output() pageChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() set menu(open: boolean) {
    this.isOpen = open;
  }
  @Output() notify = new EventEmitter<boolean>();
  private elSignaturesList: ElementRef;

  @ViewChild('signatures') set content(content: ElementRef) {
    if(content) {
        this.elSignaturesList = content;
    }
 }

  error$ = new Subject<any>();
  documentOpened: any;
  documents = [];
  uuid: string
  params: any;
  collaborator: any;

  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;
  loading = true;
  isOpen = false;
  isLoading = true;
  contactsList = [];
  enableSimpleShippingComponent = false;
  enableSignaturesListComponent = false;

  constructor(
   private featureFlagService: DataAccessFeatureFlagService,
   private employeesService: EmployeesService,
   private segment: TrackingSegmentService,
   private activatedRoute: ActivatedRoute,
   private router: Router,
   public cd: ChangeDetectorRef,
  ) {
    document.addEventListener('signaturesEventListener', this.signaturesClickHandler.bind(this));
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.uuid = params.p;
    });

    this.featureFlagService.hasFlag({
      flag_key: 'people-employee_enable_sign_shipping_component',
      entity_id: ' ',
      context: {
          organization_id: SessionStorage.getItem('organization')
      }}
    ).subscribe(flag => this.enableSimpleShippingComponent = flag?.match)

    this.featureFlagService.hasFlag({
      flag_key: 'people-employee_enable_signatures_list_component',
      entity_id: ' ',
      context: {
          organization_id: SessionStorage.getItem('organization')
      }}
    ).subscribe(flag => this.enableSignaturesListComponent = flag?.match)

    this.collaborator = SessionStorage.getItem('collaborator')
    this.contactsList.push(this.collaborator);
    this.loadDocuments();
  }

  loadDocuments() {
    this.documents = [];
    this.employeesService.getDocumentsEmployee(this.uuid, this.currentPage)
      .subscribe(res => {
        this.totalItems = res.Count;
        if (this.totalItems > 0) {
          res.Envelopes.forEach( envelope => {
            console.log(envelope);
            envelope.documents.forEach( document => {
              const obj = {
                envelopeStatus: envelope.envelopeStatus,
                id_envelopeStatus: envelope.idEnvelopeStatus,
                documentType: document.documentType,
                createdDate: document.createdDate,
                documentCategoryName: document.documentCategoryName,
                emitterUserName: document.emitterUserName,
                emitterUserEmail: document.emitterUserEmail,
                url: document.url,
                uuid: document.UUID,
                subscribers: []
              };
              document.subscribers.forEach(subs => {
                const subscriber = {
                  subscriberOrder: subs.subscriberOrder,
                  subscriberName: subs.subscriberName,
                  subscriberPhone: subs.subscriberPhone,
                  subscriberEmail: subs.subscriberEmail,
                  subscriberCpf: subs.subscriberCPF
                }
                obj.subscribers.push(subscriber);
              });

              this.documents.push(obj);
            });
          });
        }
        this.isLoading = false;
        this.cd.detectChanges();
        if (this.enableSignaturesListComponent) {
          this.elSignaturesList.nativeElement.setAttribute('documents-list', JSON.stringify(this.documents));
        }
      });
  }

  onChange(event: number): void {
    this.currentPage = event;
    this.loadDocuments();
  }

  openDocumet(documentId) {
    this.documents.map(doc => {
      if (doc.uuid == documentId) {
        doc.openLoading = !doc.openLoading
      }
    });
    this.elSignaturesList.nativeElement.setAttribute('documents-list', JSON.stringify(this.documents));
    this.employeesService.downloadDocumentEmployee(this.uuid, documentId)
    .subscribe(res => {
      let url = window.URL.createObjectURL(res);
      let a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.documents.map(doc => {
        if (doc.uuid == documentId) {
          doc.openLoading = !doc.openLoading
        }});
        this.elSignaturesList.nativeElement.setAttribute('documents-list', JSON.stringify(this.documents));
    });
  }

  downloadDocumet(documentId) {
    this.loading = true;
    this.documents.map(doc => {
      if (doc.uuid == documentId) {
        doc.downloadLoading = !doc.downloadLoading
      }});
      this.elSignaturesList.nativeElement.setAttribute('documents-list', JSON.stringify(this.documents));
    this.employeesService.downloadDocumentEmployee(this.uuid, documentId)
    .subscribe(res => {
      let url = window.URL.createObjectURL(res);
      let a = document.createElement('a');
      a.href = url;
      a.download = documentId;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.documents.map(doc => {
        if (doc.uuid == documentId) {
          doc.downloadLoading = !doc.downloadLoading
        }});
        this.elSignaturesList.nativeElement.setAttribute('documents-list', JSON.stringify(this.documents));
    });
  }

  openDetails(documentSelected): void {
    const body = document.getElementsByTagName('body')[0];
    this.isOpen = !this.isOpen;
    this.notify.emit(this.isOpen);
    this.documentOpened = documentSelected;

    if (this.isOpen) {
      body.classList.add('sidebar-is-open', 'sidebar-has-scroll');
      this.trackinSegment(SegmentEventName.document_sidepanel, 'Listagem');
    } else {
      body.classList.remove('sidebar-is-open');
    }
  }

  onNotify(notify: boolean): void {
    this.isOpen = notify;
  }

  trackinSegment(eventTitle, location) {
    this.segment.track(eventTitle, {
      status: this.documentOpened.envelopeStatus,
      category: this.documentOpened.documentCategoryName,
      location: location
    });
  }

  shippingDocuments() {
    this.segment.track(SegmentEventName.shipping_document, {
      status: this.collaborator.active ? 'ativo' : 'inativo',
      location: 'Perfil de Colaborador'
    });
    SessionStorage.setItem('contactsList', this.contactsList);
    this.router.navigate(['/shipping']);
  }

  signaturesClickHandler(event: any): void {
    this.documentOpened = this.documents.find(doc => doc.uuid == event?.detail?.data?.docId);

    if ( event?.detail?.action === 'download' ) {
      this.trackinSegment(SegmentEventName.document_download, event?.detail?.data?.location);
      this.downloadDocumet(event?.detail?.data?.docId);
    }
    if ( event?.detail?.action === 'openDocument' ) {
      this.trackinSegment(SegmentEventName.document_opened, event?.detail?.data?.location);
      this.openDocumet(event?.detail?.data?.docId);
    }
    if ( event?.detail?.action === 'openDetails' ) {
      this.trackinSegment(SegmentEventName.document_sidepanel, 'Listagem');
      this.trackinSegment(SegmentEventName.document_details, event?.detail?.data?.location);
    }
    if ( event?.detail?.action === 'openCpf' ) {
      this.trackinSegment(SegmentEventName.document_show_cpf, event?.detail?.data?.location);
    }
  }
}
